import GridIcon from '@/assets/icons/grid.svg?react';
import TableIcon from '@/assets/icons/table.svg?react';
import { FilterInput } from '@/components/elements/filter-input/filter-input.component';
import { SearchInput } from '@/components/elements/search-input/search-input.component';
import Button from '@/components/ui/button/button.component';
import React from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  context: 'products' | 'templates' | 'product-groups';
  searchPlaceholder: string;
  filterBarText: React.ReactNode;
  filterBarOptionAllProducts: React.ReactNode;
  filterBarOptionMyProducts: React.ReactNode;
  tableViewButton: React.ReactNode;
  gridViewButton: React.ReactNode;

  onHandleViewChange: () => void;
  selectedView: 'grid' | 'table';

  filter: string;
  onHandleFilterChange: (filter: string) => void;

  onHandleSearchChange: (search: string) => void;
}

export const ActionBar = ({
  context,
  searchPlaceholder,
  filterBarText,
  filterBarOptionAllProducts,
  filterBarOptionMyProducts,
  tableViewButton,
  gridViewButton,
  selectedView,
  onHandleViewChange: handleViewChange,
  filter,
  onHandleFilterChange: handleFilterChange,
  onHandleSearchChange,
}: Props) => {
  return (
    <div className="mb-6 flex flex-row justify-between items-center">
      <SearchInput
        data-testid={`${context}-page-search`}
        placeholder={searchPlaceholder}
        onSearch={(e) => {
          const search = e.target.value;
          onHandleSearchChange(search);
        }}
      />
      <div className="flex flex-row items-center gap-x-4">
        <div className="flex flex-row items-center gap-x-2">
          <p className="typo-secondary">{filterBarText}</p>
          <FilterInput
            value={filter}
            options={[
              {
                value: 'ALL',
                label: filterBarOptionAllProducts,
                testId: 'filter-bar-option-all-products',
              },
              {
                value: 'MINE',
                label: filterBarOptionMyProducts,
                testId: 'filter-bar-option-my-products',
              },
            ]}
            data-testid={`${context}-page-filter-bar`}
            onFilterChange={handleFilterChange}
          />
        </div>
        <Button
          data-testid={`${context}-page-view-trigger`}
          onClick={handleViewChange}
          size="small"
          variant="secondary"
        >
          {selectedView === 'grid' && (
            <>
              <TableIcon className="w-5 mr-2" />
              {tableViewButton}
            </>
          )}
          {selectedView === 'table' && (
            <>
              <GridIcon className="w-5 mr-2" />
              {gridViewButton}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
